"use strict";function i(i){return i&&"object"==typeof i&&"default"in i?i:{default:i}}var t=i(require("styled-components")).default.section`
    position: relative;
    margin: 0;
    padding: 0 25px 64px;
    @media (min-width: 992px) {
        padding: 0 25px 91px;
    }
    &::after {
        display: block;
        content: '';
        position: absolute;
        width: 100%;
        height: calc(100% - 142px);
        left: 0;
        bottom: 0;
        z-index: -1;
        background: #0c1e34;

        @media (min-width: 992px) {
            height: calc(100% - 224px);
        }
    }
    .inner {
        max-width: 512px;
        margin: 0 auto;
        padding: 0 25px;
        display: grid;
        grid-row-gap: 50px;
        background: ${({theme:i})=>i.colors.primary.default};
        border-radius: 4px;
        color: ${({theme:i})=>i.colors.common.light};
        box-sizing: border-box;
    }
    .content {
        padding: 42px 0 31px;
        .DXPrefooterCTA-header {
            font-size: 34px;
            font-weight: bold;
            line-height: 40px;
            margin: 0 0 10px;
        }
        .DXButton {
            background-color:${({theme:i})=>i.colors.common.light};
            color: ${({theme:i})=>i.colors.primary.default};
            padding: 27px;
        }
    }
    picture {
        width: calc(100% + 20px);
        margin-left: -10px;
        height: 0;
        padding-top: 106%;
        position: relative;
        margin-bottom: -32px;
        img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 4px;
            z-index: 1;
        }
        .icon-person {
            position: absolute;
            bottom: -27px;
            right: -12px;
            height: 95%;
            width: auto;
            z-index: 2;
        }
        .icon-cat {
            position: absolute;
            bottom: -27px;
            right: 27%;
            height: 27%;
            width: auto;
            z-index: 2;
        }
        .icon-background_leaf {
            display: none;
        }
        .icon-background_leaf_2 {
            position: absolute;
            top: -14%;
            right: 8%;
            height: 21%;
            width: auto;
        }
    }
    @media screen and (min-width: 992px) {
        .inner {
            max-width: 1224px;
            grid-template-columns: 1fr minmax(auto, 496px);
            grid-column-gap: 28px;
            grid-row-gap: 0;
            padding: 0 104px 0 0;
        }
        .content {
            max-width: 390px;
            padding: 104px 107px;
            .DXPrefooterCTA-header {
                font-size: 40px;
                line-height: 48px;
                margin: 0 0 21px;
            }
            .DXButton {
                margin: 29px 0 0;
            }
        }
        picture {
            margin: 61px 0 -61px auto;
            .icon-person {
                right: -75px;
            }
            .icon-cat {
                right: 14%;
            }
            .icon-background_leaf {
                display: block;
                position: absolute;
                bottom: 60px;
                left: -10%;
                height: 21%;
                width: auto;
            }
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
